export const DATA_QA_ADELIVERY_METHODS = 'adelivery-methods';
